'use client';
import React from 'react';
import Link from 'next/link';

const projects = [
{
  id: 1,
  name: 'Neo Heights',
  location: 'Near Future City, Kadthal',
  area: '23 Acres + 33 Acres Extension',
  status: 'New Launch',
  statusColor: 'bg-brand-turmeric',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1fcc54689-1786114685165.png",
  alt: 'Neo Heights upcoming premium villa plots near Hyderabad with lush green landscape and modern amenities',
  features: ['DTCP Approved', 'RERA Registered'],
  href: '/projects/neo-heights',
},
{
  id: 2,
  name: 'Neo Central',
  location: 'Ideally located between the Srisailam and New Tirupati Highways',
  area: '12 Acres + 12 Acres Extension',
  status: 'New Launch',
  statusColor: 'bg-brand-turmeric',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_14e86477b-1787057103688.png",
  alt: 'Aerial view of Neo Central premium plotted development near Regional Ring Road Amangal Peddapur with wide roads',
  features: ['DTCP Approved', 'RERA Registered'],
  href: '/projects/neo-central',
},
{
  id: 3,
  name: 'Neo Highway Meadows',
  location: 'Located on the Srisailam Highway, Veldanda',
  area: '20 Acres + 80 Acres Extension',
  status: 'Coming Soon',
  statusColor: 'bg-brand-turmeric',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1c1117360-1787566619043.png",
  alt: 'Neo Highway Meadows premium residential plots on Srisailam Highway at Veldanda with scenic surroundings',
  features: ['DTCP Approved', 'RERA Registered'],
  href: '/projects/neo-highway-meadows',
  hideViewDetails: true,
}];

const upcomingProjects = [
{
  id: 1,
  name: 'Hyderabad',
  locations: ['Shadnagar', 'Vikarabad', 'Sadashivpet'],
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1fcf5fc89-1772295305155.png",
  alt: 'Premium plotted venture development in Hyderabad outskirts with wide roads and green landscaping'
},
{
  id: 2,
  name: 'Andhra Pradesh',
  locations: ['Visakhapatnam (Vizag)', 'Amaravati'],
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_121a4d11f-1787569013692.png",
  alt: 'Upcoming residential venture plots in Andhra Pradesh with scenic coastal and capital city locations'
},
{
  id: 3,
  name: 'Karnataka',
  locations: ['Bengaluru'],
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1b9573fa7-1769835068527.png",
  alt: 'Premium land venture development near Bengaluru Karnataka with modern infrastructure and connectivity'
}];


export default function ProjectsSection() {
  return (
    <>
      <section id="projects" className="py-16 md:py-20 bg-white">
        <div className="container mx-auto px-4 max-w-6xl">
          {/* Header */}
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-brand-dark font-avenir mb-3">
              Our Projects
            </h2>
            <hr className="border-0 h-0.5 bg-brand-green w-20 mx-auto mb-4" />
            <p className="text-brand-gray font-avenir text-sm max-w-xl mx-auto">
              Explore our portfolio of premium plotted ventures near Hyderabad — legally verified, strategically located, and designed for high-value investment and long-term wealth creation.
            </p>
          </div>

          {/* Projects Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {projects?.map((project) =>
            <div
              key={project?.id}
              className="group bg-white rounded-2xl overflow-hidden shadow-card hover:shadow-card-hover transition-all duration-300 border border-brand-turmeric/10">
              
                {/* Image */}
                <div className="relative overflow-hidden h-52">
                  <img
                  src={project?.image}
                  alt={project?.alt}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                
                  {/* Status Badge */}
                  <div className={`absolute top-3 left-3 ${project?.statusColor} text-white text-xs font-semibold font-avenir px-3 py-1 rounded-full`}>
                    {project?.status}
                  </div>
                  {/* Dark overlay on hover */}
                  <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors duration-300" />
                </div>

                {/* Content */}
                <div className="p-5">
                  <h3 className="text-brand-dark font-bold font-avenir text-base mb-1 group-hover:text-brand-green transition-colors duration-200">
                    {project?.name}
                  </h3>
                  <div className="flex items-center gap-1 text-brand-gray font-avenir text-xs mb-3">
                    <svg className="w-3 h-3 text-brand-turmeric" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>
                    {project?.location}
                  </div>

                  {/* Area */}
                  <div className="flex items-center gap-2 mb-3">
                    <span className="text-brand-turmeric font-avenir text-xs font-semibold">📍 {project?.area}</span>
                  </div>

                  {/* Features */}
                  <div className="flex flex-wrap gap-1 mb-4">
                    {project?.features?.map((feature) =>
                  <span
                    key={feature}
                    className="text-xs font-avenir px-2 py-0.5 rounded-full bg-brand-bg-light text-brand-green font-medium border border-brand-green/20">
                    
                        {feature}
                      </span>
                  )}
                  </div>

                  {/* CTAs */}
                  <div className="flex gap-2">
                    {!project?.hideViewDetails && (
                    <Link
                      href={project?.href}
                      className="flex-1 block text-center py-2.5 border border-brand-green text-brand-green font-semibold rounded-lg font-avenir text-sm hover:bg-brand-green hover:text-white transition-colors duration-200">
                      View Details
                    </Link>
                    )}
                    <a
                    href="#contact"
                    className={`${project?.hideViewDetails ? 'w-full' : 'flex-1'} block text-center py-2.5 bg-brand-green text-white font-semibold rounded-lg font-avenir text-sm hover:bg-brand-green-light transition-colors duration-200`}>
                      Enquire Now
                    </a>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </section>
      {/* Upcoming Projects Section */}
      <section id="upcoming-projects" className="py-16 md:py-20 bg-brand-bg-light">
        <div className="container mx-auto px-4 max-w-6xl">
          {/* Header */}
          <div className="text-center mb-12">
            <h6 className="text-brand-turmeric font-avenir text-sm font-semibold uppercase tracking-widest mb-2">
              # Expanding Horizons
            </h6>
            <h2 className="text-3xl md:text-4xl font-bold text-brand-dark font-avenir mb-3">
              Upcoming Projects
            </h2>
            <hr className="border-0 h-0.5 bg-brand-green w-20 mx-auto mb-4" />
            <p className="text-brand-gray font-avenir text-sm max-w-xl mx-auto">
              Neo Capital Group is expanding across South India. Discover our upcoming premium plotted ventures in high-growth corridors across Hyderabad, Andhra Pradesh, and Karnataka.
            </p>
          </div>

          {/* Upcoming Projects Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {upcomingProjects?.map((project) =>
            <div
              key={project?.id}
              className="group bg-white rounded-2xl overflow-hidden shadow-card hover:shadow-card-hover transition-all duration-300 border border-brand-turmeric/10">

                {/* Image */}
                <div className="relative overflow-hidden h-52">
                  <img
                  src={project?.image}
                  alt={project?.alt}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />

                  {/* Coming Soon Badge */}
                  <div className="absolute top-3 left-3 bg-brand-dark/80 text-white text-xs font-semibold font-avenir px-3 py-1 rounded-full">
                    Coming Soon
                  </div>
                  <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors duration-300" />
                </div>

                {/* Content */}
                <div className="p-5">
                  <h3 className="text-brand-dark font-bold font-avenir text-base mb-3 group-hover:text-brand-green transition-colors duration-200">
                    {project?.name}
                  </h3>

                  {/* Locations */}
                  <div className="space-y-1.5 mb-4">
                    {project?.locations?.map((loc) =>
                  <div key={loc} className="flex items-center gap-1.5 text-brand-gray font-avenir text-xs">
                        <svg className="w-3 h-3 text-brand-turmeric flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                        </svg>
                        {loc}
                      </div>
                  )}
                  </div>

                  {/* Register Interest CTA */}
                  <a
                  href="#contact"
                  className="block text-center py-2.5 border border-brand-green text-brand-green font-semibold rounded-lg font-avenir text-sm hover:bg-brand-green hover:text-white transition-colors duration-200 whitespace-nowrap">

                    Register Interest
                  </a>
                </div>
              </div>
            )}
          </div>
        </div>
      </section>
    </>
  );
}